<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized" class="cs_wrapper">
  <div *ngIf="!isShared" class="row">
    <div class="col-lg-12 mt-1 mb-2">
      <div class="float-right d-none d-lg-block">
        <a href="javascript:void(0)" (click)="onCopyLink()" class="btn btn-sm btn-primary ml-2"> Shareable Link </a>
      </div>
    </div>
  </div>
  <table>
    <thead>
      <tr>
        <td>
          <div class="cs_header">
            <div class="cs_list">
              <div class="cs_list-item">
                <span class="cs_hl">Name:</span> {{assessment.user.firstName}} {{assessment.user.lastName}}
              </div>
              <div class="cs_list-item">
                <span class="cs_hl">Date:</span> {{assessment.dateTime | date:'short' }}
              </div>
            </div>
            <a href="https://rundna.com/" target="_blank"><img class="cs_logo" src="../../../../assets/img/gaitreport/logo.png" alt="logo" /></a>
          </div>
        </td>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <!-- page 1 -->
          <div class="card card-body">
            <div class="cs_sec-header dark cs_mt1">
              <div class="cs_sec-left">
                <div>
                  <h2>Runner</h2>
                  <h2>Readiness</h2>
                  <h2>Assessment</h2>
                </div>
              </div>
              <div class="cs_sec-right">
                The Runner Readiness Assessment (RRA) is a test of your
                flexibility, strength, and stability. These tests are designed to
                identify areas closely related to walking/balance that should be
                addressed, but do not indicate your risk of injury from running.
              </div>
            </div>

            <div class="cs_card-grid cs_mt2">
              <div class="cs_card overal cs_black">

                <div class="cs_overal-score">
                  <div class="cs_overal-score-item color-1"></div>
                  <div class="cs_overal-score-item color-2"></div>
                  <div class="cs_overal-score-item color-3"></div>
                  <div class="cs_overal-score-item color-4"></div>
                  <div class="cs_overal-score-item color-5"></div>
                </div>
                <h3 class="cs_card-title overal-title">
                  <div>Overall<br>Score</div>
                  <div class="cs_score handicap_score sm color-{{assessment.scoreGrade}}">{{assessment.handicapScore}}</div>
                </h3>
              </div>


              <div class="cs_card cs_black cs_content-center">
                <h3 class="cs_card-title">Your RRA Program</h3>
                <div *ngIf="assessment.program">
                  <div class="cs_highlight">
                    <a href="javascript:void(0)" [routerLink]="[programUrl, assessment.program.id]">{{ (assessment.program.name.length > 30) ? (assessment.program.name | slice:0:30) + '...' : (assessment.program.name) }}</a>
                  </div>
                  <p>
                    {{ (rraProgramDescription.length> 140) ? (rraProgramDescription | slice:0:140) + '...' : (rraProgramDescription)}}
                  </p>
                </div>
                <div *ngIf="!assessment.program">
                  <div class="cs_highlight">
                    <a href="javascript:void(0)">Unassigned</a>
                  </div>
                  <p>
                  </p>
                </div>
              </div>


              <div class="cs_card cs_card_full_screen">
                <img src="../../../../assets/img/gaitreport/img_0002.svg" alt="" class="cs_card-image img-2">
                <h3 class="cs_card-title-with-score">
                  Fundamental Movements
                  <span class="cs_card-title-value">({{assessment.fundamentalMovementsScore}}/{{assessment.maxFundamentalMovementsScore}})</span>
                </h3>

                <h4 class="cs_card-subtitle">Combined Functional Movements</h4>
                <div class="cs_card-list">
                  <div class="cs_card-list-item">
                    <div class="cs_card-list-item-col">
                    </div>
                    <div class="cs_card-list-item-col cs_bold cs_notes-label">
                      Left
                    </div>
                    <div class="cs_card-list-item-col cs_bold cs_notes-label">
                      Right
                    </div>
                  </div>

                  <div class="cs_card-list-item">
                    <div class="cs_card-list-item-col btn-gc category-item" (click)="showHelp('toeTouch')">
                      Toe Touch
                    </div>
                    <div class="cs_card-list-item-col cs_span-2">
                      <div class="cs_score sm s-{{ getAssessmentValue('5 Fundamental Movements','Toe Touch', '')  | enumString: RRAssessmentResultShortEnum | lowercase }}">{{getAssessmentValue('5 Fundamental Movements','Toe Touch', '') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                  </div>
                  <div class="cs_card-list-item">
                    <div class="cs_card-list-sub-item-col btn-gc" (click)="showHelp('toeTouchStraighLegRaise')">
                      Straight Leg Raise
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('5 Fundamental Movements','Toe Touch', 'Straight Leg Raise - Left') | enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('5 Fundamental Movements','Toe Touch', 'Straight Leg Raise - Left') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('5 Fundamental Movements','Toe Touch', 'Straight Leg Raise - Right')| enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('5 Fundamental Movements','Toe Touch', 'Straight Leg Raise - Right') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                  </div>
                  <div class="cs_card-list-item">
                    <div class="cs_card-list-sub-item-col btn-gc" (click)="showHelp('toeTouchChildPose')">
                      Child’s Pose
                    </div>
                    <div class="cs_card-list-item-col cs_span-2">
                      <div class="cs_score sm s-{{ getAssessmentValue('5 Fundamental Movements','Toe Touch','Child Pose')  | enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('5 Fundamental Movements','Toe Touch','Child Pose') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                  </div>

                  <!-- Back Bend  -->
                  <div class="cs_separator"></div>

                  <div class="cs_card-list-item">
                    <div class="cs_card-list-item-col btn-gc category-item" (click)="showHelp('backBend')">
                      Back Bend
                    </div>
                    <div class="cs_card-list-item-col cs_span-2">
                      <div class="cs_score sm s-{{ getAssessmentValue('5 Fundamental Movements','Back Bend', '')  | enumString: RRAssessmentResultShortEnum | lowercase }}">{{getAssessmentValue('5 Fundamental Movements','Back Bend', '') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                  </div>
                  <div class="cs_card-list-item">
                    <div class="cs_card-list-sub-item-col btn-gc" (click)="showHelp('backBendProneHipExtension')">
                      Prone Hip Extension
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('5 Fundamental Movements','Back Bend', 'Prone Hip Extension - Left') | enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('5 Fundamental Movements','Back Bend', 'Prone Hip Extension - Left') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('5 Fundamental Movements','Back Bend', 'Prone Hip Extension - Right')| enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('5 Fundamental Movements','Back Bend', 'Prone Hip Extension - Right') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                  </div>
                  <div class="cs_card-list-item">
                    <div class="cs_card-list-sub-item-col btn-gc" (click)="showHelp('backBendPronePressUp')">
                      Prone Press Up
                    </div>
                    <div class="cs_card-list-item-col cs_span-2">
                      <div class="cs_score sm s-{{ getAssessmentValue('5 Fundamental Movements','Back Bend', 'Prone Press Up')  | enumString: RRAssessmentResultShortEnum | lowercase }}">{{getAssessmentValue('5 Fundamental Movements','Back Bend', 'Prone Press Up') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                  </div>

                  <!-- Rotation  -->
                  <div class="cs_separator"></div>

                  <div class="cs_card-list-item">
                    <div class="cs_card-list-item-col btn-gc category-item" (click)="showHelp('rotation')">
                      Rotation
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('5 Fundamental Movements','Rotation', '') | enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('5 Fundamental Movements','Rotation', '') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('5 Fundamental Movements','Rotation', '')| enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('5 Fundamental Movements','Rotation', '') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                  </div>
                  <div class="cs_card-list-item">
                    <div class="cs_card-list-sub-item-col btn-gc" (click)="showHelp('rotationQuadrupedRotation')">
                      Quadruped Rotation
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('5 Fundamental Movements','Rotation', 'Quadruped Rotation - Left') | enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('5 Fundamental Movements','Rotation', 'Quadruped Rotation - Left') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('5 Fundamental Movements','Rotation', 'Quadruped Rotation - Right')| enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('5 Fundamental Movements','Rotation', 'Quadruped Rotation - Right') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                  </div>
                  <div class="cs_card-list-item">
                    <div class="cs_card-list-sub-item-col btn-gc" (click)="showHelp('rotationProneHipExternalRotation')">
                      External Prone Hip Rotation
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('5 Fundamental Movements','Rotation', 'External Prone Hip Rotation - Left') | enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('5 Fundamental Movements','Rotation', 'External Prone Hip Rotation - Left') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('5 Fundamental Movements','Rotation', 'External Prone Hip Rotation - Right')| enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('5 Fundamental Movements','Rotation', 'External Prone Hip Rotation - Right') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                  </div>
                  <div class="cs_card-list-item">
                    <div class="cs_card-list-sub-item-col btn-gc" (click)="showHelp('rotationProneHipInternalRotation')">
                      Internal Prone Hip Rotation
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('5 Fundamental Movements','Rotation', 'Internal Prone Hip Rotation - Left') | enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('5 Fundamental Movements','Rotation', 'Internal Prone Hip Rotation - Left') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('5 Fundamental Movements','Rotation', 'Internal Prone Hip Rotation - Right')| enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('5 Fundamental Movements','Rotation', 'Internal Prone Hip Rotation - Right') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                  </div>

                  <!-- Single Leg Balance  -->
                  <div class="cs_separator"></div>

                  <div class="cs_card-list-item">
                    <div class="cs_card-list-item-col btn-gc category-item" (click)="showHelp('singleLegBalance')">
                      Single Leg Balance
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('5 Fundamental Movements','Single Leg Balance', '') | enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('5 Fundamental Movements','Single Leg Balance', '') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('5 Fundamental Movements','Single Leg Balance', '')| enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('5 Fundamental Movements','Single Leg Balance', '') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                  </div>
                  <div class="cs_card-list-item">
                    <div class="cs_card-list-sub-item-col btn-gc" (click)="showHelp('singleLegBalanceHalfKneel')">
                      Half Kneel
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('5 Fundamental Movements','Single Leg Balance', 'Half Kneel - Left') | enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('5 Fundamental Movements','Single Leg Balance', 'Half Kneel - Left') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('5 Fundamental Movements','Single Leg Balance', 'Half Kneel - Right')| enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('5 Fundamental Movements','Single Leg Balance', 'Half Kneel - Right') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                  </div>
                  <div class="cs_card-list-item">
                    <div class="cs_card-list-sub-item-col btn-gc" (click)="showHelp('singleLegBalanceFootAssessment')">
                      Foot Assessment
                    </div>
                    <div class="cs_card-list-item-col cs_span-2">
                      <div class="cs_score sm s-{{ getAssessmentValue('5 Fundamental Movements','Single Leg Balance', 'Foot Assessment')  | enumString: RRAssessmentResultShortEnum | lowercase }}">{{getAssessmentValue('5 Fundamental Movements','Single Leg Balance', 'Foot Assessment') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                  </div>

                  <!--  Squat  -->
                  <div class="cs_separator"></div>

                  <div class="cs_card-list-item">
                    <div class="cs_card-list-item-col btn-gc category-item" (click)="showHelp('squat')">
                      Squat
                    </div>
                    <div class="cs_card-list-item-col cs_span-2">
                      <div class="cs_score sm s-{{ getAssessmentValue('5 Fundamental Movements','Squat', '')  | enumString: RRAssessmentResultShortEnum | lowercase }}">{{getAssessmentValue('5 Fundamental Movements','Squat', '') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                  </div>
                  <div class="cs_card-list-item">
                    <div class="cs_card-list-sub-item-col btn-gc" (click)="showHelp('squatDKTC')">
                      Double Knee to Chest
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('5 Fundamental Movements','Squat', 'DKTC - Left') | enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('5 Fundamental Movements','Squat', 'DKTC - Left') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('5 Fundamental Movements','Squat', 'DKTC - Right')| enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('5 Fundamental Movements','Squat', 'DKTC - Right') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                  </div>
                  <div class="cs_card-list-item">
                    <div class="cs_card-list-sub-item-col btn-gc" (click)="showHelp('squatLungeDorsiflexion')">
                      Lunge Dorsiflexion
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('5 Fundamental Movements','Squat', 'Lunge Dorsiflextion - Left') | enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('5 Fundamental Movements','Squat', 'Lunge Dorsiflextion - Left') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('5 Fundamental Movements','Squat', 'Lunge Dorsiflextion - Right')| enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('5 Fundamental Movements','Squat', 'Lunge Dorsiflextion - Right') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                  </div>

                </div>
              </div>

              <div class="cs_sec-header dark">
                <div class="cs_sec-left-fit sec-score">
                  <div class="cs_sec-score-item">
                    <h5>Able</h5>
                    <div class="cs_score lg s-a">A</div>
                  </div>
                  <div class="cs_sec-score-item">
                    <h5>Able Pain</h5>
                    <div class="cs_score lg s-ap">AP</div>
                  </div>
                  <div class="cs_sec-score-item">
                    <h5>Unable</h5>
                    <div class="cs_score lg s-u">U</div>
                  </div>
                  <div class="cs_sec-score-item">
                    <h5>Unable Pain</h5>
                    <div class="cs_score lg s-up">UP</div>
                  </div>
                </div>
                <div class="cs_sec-right">
                  Tests are scored as Able, Able Pain, Unable, or Unable Pain.
                  It is common that if there is one area for improvement, it
                  will impact multiple tests. Improving strength or flexibility in
                  one area may improve other tests.
                </div>
              </div>
            </div>
          </div>
          <hr class="cs_page-break" />

          <!-- page 2 -->
          <div class="card card-body">
            <div class="cs_card-grid cs_mt2">

              <div class="cs_card cs_card_full_screen">
                <img src="../../../../assets/img/gaitreport/img_0003.svg" alt="" class="cs_card-image img-3">
                <h3 class="cs_card-title-with-score">
                  Motor Control
                  <span class="cs_card-title-value">({{assessment.motorControlScore}}/{{assessment.maxMotorControlScore}})</span>
                </h3>
                <h4 class="cs_card-subtitle">Strength & Control</h4>
                <div class="cs_card-list">
                  <div class="cs_card-list-item">
                    <div class="cs_card-list-item-col">
                    </div>
                    <div class="cs_card-list-item-col cs_bold cs_notes-label">
                      Left
                    </div>
                    <div class="cs_card-list-item-col cs_bold cs_notes-label">
                      Right
                    </div>
                  </div>
                  <div class="cs_card-list-item">
                    <div class="cs_card-list-item-col btn-gc category-item" (click)="showHelp('singleLegSitToStand')">
                      Single Leg Sit to Stand
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('Motor Control','Single Leg Sit To Stand - Left', '') | enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('Motor Control','Single Leg Sit To Stand - Left', '') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('Motor Control','Single Leg Sit To Stand - Right', '')| enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('Motor Control','Single Leg Sit To Stand - Right', '') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                  </div>
                  <div class="cs_separator"></div>
                  <div class="cs_card-list-item">
                    <div class="cs_card-list-item-col btn-gc category-item" (click)="showHelp('singleLegCalfRaise')">
                      Single Leg Calf Raise
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('Motor Control','Single Leg Calf Raise - Left', '') | enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('Motor Control','Single Leg Calf Raise - Left', '') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('Motor Control','Single Leg Calf Raise - Right', '')| enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('Motor Control','Single Leg Calf Raise - Right', '') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                  </div>
                  <div class="cs_separator"></div>
                  <div class="cs_card-list-item">
                    <div class="cs_card-list-item-col btn-gc category-item" (click)="showHelp('sidePlank')">
                      Side Plank
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('Motor Control','Side Plank - Left', '') | enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('Motor Control','Side Plank - Left', '') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('Motor Control','Side Plank - Right', '')| enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('Motor Control','Side Plank - Right', '') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                  </div>
                  <div class="cs_separator"></div>
                  <div class="cs_card-list-item">
                    <div class="cs_card-list-item-col btn-gc category-item" (click)="showHelp('unilateralHipBridgeEndurance')">
                      Unilateral Hip Bridge Endurance
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('Motor Control','Unilateral Hip Bridge Endurance - Left', '') | enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('Motor Control','Unilateral Hip Bridge Endurance - Left', '') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('Motor Control','Unilateral Hip Bridge Endurance - Right', '')| enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('Motor Control','Unilateral Hip Bridge Endurance - Right', '') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="cs_card cs_card_full_screen">
                <img src="../../../../assets/img/gaitreport/img_0001.svg" alt="" class="cs_card-image img-1">
                <h3 class="cs_card-title-with-score">
                  Foot Assessment
                  <span class="cs_card-title-value">({{assessment.footAssessmentScore}}/{{assessment.maxFootAssessmentScore}})</span>
                </h3>
                <h4 class="cs_card-subtitle">Foot Coordinated Movements</h4>
                <div class="cs_card-list">
                  <div class="cs_card-list-item">
                    <div class="cs_card-list-item-col">
                    </div>
                    <div class="cs_card-list-item-col cs_bold cs_notes-label">
                      Left
                    </div>
                    <div class="cs_card-list-item-col cs_bold cs_notes-label">
                      Right
                    </div>
                  </div>
                  <div class="cs_card-list-item">
                    <div class="cs_card-list-item-col btn-gc category-item" (click)="showHelp('toeSplay')">
                      Toe Splay
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('Foot Assessment','Toe Splay - Left', '') | enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('Foot Assessment','Toe Splay - Left', '') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('Foot Assessment','Toe Splay - Right', '')| enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('Foot Assessment','Toe Splay - Right', '') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                  </div>
                  <div class="cs_separator"></div>
                  <div class="cs_card-list-item">
                    <div class="cs_card-list-item-col btn-gc category-item" (click)="showHelp('halluxExtension')">
                      Hallux Extension
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('Foot Assessment','Hallux Extension - Left', '') | enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('Foot Assessment','Hallux Extension - Left', '') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('Foot Assessment','Hallux Extension - Right', '')| enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('Foot Assessment','Hallux Extension - Right', '') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                  </div>
                  <div class="cs_separator"></div>
                  <div class="cs_card-list-item">
                    <div class="cs_card-list-item-col btn-gc category-item" (click)="showHelp('halluxExtensionAbduction')">
                      Hallux Abduction
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('Foot Assessment','Hallux Abduction - Left', '') | enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('Foot Assessment','Hallux Abduction - Left', '') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('Foot Assessment','Hallux Abduction - Right', '')| enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('Foot Assessment','Hallux Abduction - Right', '') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                  </div>
                  <div class="cs_separator"></div>
                  <div class="cs_card-list-item">
                    <div class="cs_card-list-item-col btn-gc category-item" (click)="showHelp('ankleEversion')">
                      Ankle Eversion
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('Foot Assessment','Ankle Eversion - Left', '') | enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('Foot Assessment','Ankle Eversion - Left', '') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('Foot Assessment','Ankle Eversion - Right', '')| enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('Foot Assessment','Ankle Eversion - Right', '') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                  </div>
                  <div class="cs_separator"></div>
                  <div class="cs_card-list-item">
                    <div class="cs_card-list-item-col btn-gc category-item" (click)="showHelp('ankleInversion')">
                      Ankle Inversion
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('Foot Assessment','Ankle Inversion - Left', '') | enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('Foot Assessment','Ankle Inversion - Left', '') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                    <div class="cs_card-list-item-col">
                      <div class="cs_score sm s-{{ getAssessmentValue('Foot Assessment','Ankle Inversion - Right', '')| enumString: RRAssessmentResultShortEnum | lowercase }}">{{ getAssessmentValue('Foot Assessment','Ankle Inversion - Right', '') | enumString: RRAssessmentResultShortEnum}}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="cs_list-item cs_notes_section">
                <span class="cs_hl">Notes:</span> {{assessment.notes}}

              </div>

              <div class="cs_sec-header dark">
                <div class="cs_sec-left-fit sec-score">
                  <div class="cs_sec-score-item">
                    <h5>Able</h5>
                    <div class="cs_score lg s-a">A</div>
                  </div>
                  <div class="cs_sec-score-item">
                    <h5>Able Pain</h5>
                    <div class="cs_score lg s-ap">AP</div>
                  </div>
                  <div class="cs_sec-score-item">
                    <h5>Unable</h5>
                    <div class="cs_score lg s-u">U</div>
                  </div>
                  <div class="cs_sec-score-item">
                    <h5>Unable Pain</h5>
                    <div class="cs_score lg s-up">UP</div>
                  </div>
                </div>
                <div class="cs_sec-right">
                  Tests are scored as Able, Able Pain, Unable, or Unable Pain.
                  It is common that if there is one area for improvement, it
                  will impact multiple tests. Improving strength or flexibility in
                  one area may improve other tests.
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
